import Vue from "vue";
import { Invoices, Payments } from "@/columns";
const vue = new Vue();
export const getReportDataFacturasMes = async function (thiss) {
  let Parameters = {
    params: {
      option: "D"
    }
  };
  let tableData = [];
  if (
    thiss.currentUser.PositionID == 34 ||
    thiss.currentUser.PositionID == 117 ||
    thiss.currentUser.PositionID == 16
  ) {
    await vue.$http
      .get("/api/MessageApi/GetInvoicesOrPaymentsStatDetails", Parameters)
      .then((resp) => {
        tableData = resp.data[0].PaymentsMonth;
        this.loading = false;
      });
  } else {
    tableData = [];
  }

  return tableData;
};

export const getReportDataFacturasVencidas = async function (thiss) {
  let Parameters = {
    params: {
      option: "E"
    }
  };
  let tableData = [];
  if (
    thiss.currentUser.PositionID == 34 ||
    thiss.currentUser.PositionID == 117 ||
    thiss.currentUser.PositionID == 16
  ) {
    await vue.$http
      .get("/api/MessageApi/GetInvoicesOrPaymentsStatDetails", Parameters)
      .then((resp) => {
        tableData = resp.data[0].PaymentsMonth;
        this.loading = false;
      });
  } else {
    tableData = [];
  }

  return tableData;
};

export const getReportDataPagosMes = async function (thiss) {
  let Parameters = {
    params: {
      option: "A"
    }
  };
  let tableData = [];
  if (
    thiss.currentUser.PositionID == 34 ||
    thiss.currentUser.PositionID == 117 ||
    thiss.currentUser.PositionID == 16
  ) {
    await vue.$http
      .get("/api/MessageApi/GetInvoicesOrPaymentsStatDetails", Parameters)
      .then((resp) => {
        tableData = resp.data[0].PaymentsMonth;
        this.loading = false;
      });
  } else {
    tableData = [];
  }

  return tableData;
};

export const getReportDataPagosMesVencidos = async function (thiss) {
  let Parameters = {
    params: {
      option: "B"
    }
  };
  let tableData = [];
  if (
    thiss.currentUser.PositionID == 34 ||
    thiss.currentUser.PositionID == 117 ||
    thiss.currentUser.PositionID == 16
  ) {
    await vue.$http
      .get("/api/MessageApi/GetInvoicesOrPaymentsStatDetails", Parameters)
      .then((resp) => {
        tableData = resp.data[0].PaymentsMonth;
        this.loading = false;
      });
  } else {
    tableData = [];
  }

  return tableData;
};

export const getReportDataPagosVencidos = async function (thiss) {
  let Parameters = {
    params: {
      option: "C"
    }
  };
  let tableData = [];
  if (
    thiss.currentUser.PositionID == 34 ||
    thiss.currentUser.PositionID == 117 ||
    thiss.currentUser.PositionID == 16
  ) {
    await vue.$http
      .get("/api/MessageApi/GetInvoicesOrPaymentsStatDetails", Parameters)
      .then((resp) => {
        tableData = resp.data[0].PaymentsMonth;
        this.loading = false;
      });
  } else {
    tableData = [];
  }

  return tableData;
};

export const ColumnsInvoices = Invoices;
export const ColumnsPayments = Payments;

export const ActionsInvoicesOrPayments = [
  {
    icon: "el-icon-edit",
    label: "Editar",
    command: "edit-eventFinaces"
  }
];
